import PageContent from "../../../common/components/atom/PageContent/PageContent";
import HeaderTitleContent from "../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import SingleUser from "../../../features/user/components/SingleUser";
import TextBox from "../../../common/components/molecule/TextBox/TextBox";
import { EditUserModale } from "../EditUserPage/EditUserPage";

export default function SingleUserPage() {
  return (
    <>
    <PageContent>
      <HeaderTitleContent
        withGoBackBtn
        SubTitleRender={
          <SingleUser.UserExtendInfo info="organization_id" emptyText="Aucun" />
        }

        rightContainer={<div style={{display: 'flex', gap: 10}}><SingleUser.EditUserBtn/> <SingleUser.DeleteUserBtn /></div>}
      >
        <SingleUser.UserExtendInfo info="user_firstname" emptyText="Aucun" />{" "}
        <SingleUser.UserExtendInfo info="user_lastname" emptyText="Aucun" />
      </HeaderTitleContent>
      <div style={{ height: 50 }} />
      <div style={{ display: "flex", gap: 20, height: "250px" }}>
        <TextBox
          style={{ height: "100%" }}
          content={[
            {
              title: "Nom",
              TextRender: () => (
                <SingleUser.UserExtendInfo info="user_lastname" emptyText="Aucun" />
              ),
            },
            {
              title: "Prénom",
              TextRender: () => (
                <SingleUser.UserExtendInfo info="user_firstname" emptyText="Aucun" />
              ),
            },

            {
              title: "Genre",
              TextRender: () => (
                <SingleUser.UserExtendInfo info="user_gender" emptyText="Aucun" />
              ),
            },

            {
              title: "Statut",
              TextRender: () => (
                  <SingleUser.UserExtendInfo info="user_orga_status" emptyText="Aucun" styled/>
              ),
            },
          ]}
        />
        <TextBox
          content={[
            {
              title: "Email",
              TextRender: () => <SingleUser.UserExtendInfo info="user_email" />,
            },
            {
              title: "Téléphone",
              TextRender: () => (
                <SingleUser.UserExtendInfo
                  info="user_phone_number"
                  emptyText="Aucun"
                />
              ),
            },
            {
              title: "Rôle",
              TextRender: () => (
               <SingleUser.UserExtendInfo info="user_orga_role" emptyText="Aucun" />
              ),
            },
            {
              title: "Organisation",
              TextRender: () => (
                <SingleUser.UserExtendInfo
                  info="organization_id"
                  emptyText="Aucun"
                />
              ),
            },
          ]}
        />
      </div>
      <div style={{ display: "flex", gap: 20, height: "200px", marginTop: 35 }}>
      <TextBox
          content={[
            {
              title: "Créer le",
              TextRender: () => <SingleUser.UserExtendInfo       info="user_orga_created_at" />,
            },
            {
              title: "Dernière connexion",
              TextRender: () => (
                <></>
              ),
            },
          ]}
        />
      </div>
    </PageContent>
    <EditUserModale/>
    </>
  );
}
